import React__default from 'react';
import GeneItem from './GeneItem.esm.js';
import SaveCustomPanelButton from './SaveCustomPanelButton.esm.js';

var GeneList = function (_a) {
    var genes = _a.genes, _b = _a.isCustomizable, isCustomizable = _b === void 0 ? false : _b, productType = _a.productType, _c = _a.shouldAllowGeneRemoval, shouldAllowGeneRemoval = _c === void 0 ? true : _c, _d = _a.shouldShowSaveCustomPanelButton, shouldShowSaveCustomPanelButton = _d === void 0 ? false : _d;
    var concepts = React__default.useMemo(function () {
        return genes.map(function (_a) {
            var code = _a.code;
            return code;
        });
    }, [genes]);
    return (React__default.createElement(React__default.Fragment, null,
        isCustomizable && (React__default.createElement("div", null,
            React__default.createElement("div", null, genes.map(function (gene) { return (React__default.createElement(GeneItem, { gene: gene, key: gene.code, shouldAllowGeneRemoval: shouldAllowGeneRemoval })); })),
            shouldShowSaveCustomPanelButton && (React__default.createElement(SaveCustomPanelButton, { concepts: concepts, isMultiTest: false, labelText: "Save individual genes as a custom order", productType: productType })))),
        !isCustomizable && genes.map(function (_a) {
            var name = _a.name;
            return name;
        }).join(', ')));
};

export { GeneList as default };
//# sourceMappingURL=GeneList.esm.js.map
